"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "flex-wrap flex-column text-left" };
const _hoisted_2 = { class: "oplus-form-radio" };
const _hoisted_3 = { class: "oplus-form-radio" };
const vue_3 = require("vue");
const provider_1 = require("../../../../provider/provider");
exports.default = (0, vue_1.defineComponent)({
    __name: 'AutoAIScheduleOptions',
    setup(__props) {
        const presenter = (0, vue_3.inject)(provider_1.autoAIPresenterInjectKey);
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("label", _hoisted_2, [
                    (0, vue_2.createElementVNode)("input", {
                        value: 0,
                        type: "radio",
                        name: "show-role-times",
                        checked: "",
                        onChange: _cache[0] || (_cache[0] = ($event) => ((0, vue_2.unref)(presenter)?.setEditExisting(false)))
                    }, null, 32 /* NEED_HYDRATION */),
                    _cache[2] || (_cache[2] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */)),
                    _cache[3] || (_cache[3] = (0, vue_2.createElementVNode)("span", null, "新しいシフトを作成", -1 /* CACHED */))
                ]),
                (0, vue_2.createElementVNode)("label", _hoisted_3, [
                    (0, vue_2.createElementVNode)("input", {
                        value: 1,
                        type: "radio",
                        name: "show-role-times",
                        onChange: _cache[1] || (_cache[1] = ($event) => ((0, vue_2.unref)(presenter)?.setEditExisting(true)))
                    }, null, 32 /* NEED_HYDRATION */),
                    _cache[4] || (_cache[4] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */)),
                    _cache[5] || (_cache[5] = (0, vue_2.createElementVNode)("span", null, "既存のシフトを編集", -1 /* CACHED */))
                ])
            ]));
        };
    }
});
